import React from 'react';
import { useTranslation } from '../../Translation';
import SidebarNav from '../../Components/SidebarNav/SidebarNav';
import SettingSidebarNav from '../../Components/SidebarNav/SettingSidebarNav';
import Badge from '../../Components/Badge';

export default function Documentation() {
    const { translate } = useTranslation();

    return (
        <div className="flex min-h-full w-full">
            <SidebarNav currentPage="settings" contentPadding={false}>
                <div className='flex-1 flex-row h-full w-full'>
                    <SettingSidebarNav currentPage="documentation" />
                    <div className='flex-1 flex flex-col ml-24 md:ml-72'>
                        <div className='flex flex-col p-2 md:p-4 lg:p-6 w-full'>
                            <h3 className='text-2xl font-bold'>{translate('setting.documentation.title')}</h3>
                            <p className='text-md text-gray-500 max-w-4xl mt-2'>{translate('setting.documentation.description')}</p>

                            <div className='flex flex-col mt-8'>
                                <div className='flex flex-col'>
                                    <h4 className='text-lg font-bold'>{translate('setting.documentation.templateVariables.title')}</h4>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-2'>{translate('setting.documentation.templateVariables.description')}</p>

                                    <div className='flex flex-col gap-2 mt-4 max-w-4xl'>
                                        <div className='flex flex-row gap-2 items-center'>
                                            <Badge text="{{contact.*}}" withoutRemove={true} color={'blue'} />
                                            <span className='text-sm md:text-md'>{translate('setting.documentation.templateVariables.contact')}</span>
                                        </div>
                                        <div className='flex flex-row gap-2 items-center'>
                                            <Badge text="{{event.*}}" withoutRemove={true} color={'blue'} />
                                            <span className='text-sm md:text-md'>{translate('setting.documentation.templateVariables.event')}</span>
                                        </div>
                                        <div className='flex flex-row gap-2 items-center'>
                                            <Badge text="{{global.*}}" withoutRemove={true} color={'blue'} />
                                            <span className='text-sm md:text-md'>{translate('setting.documentation.templateVariables.global')}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className='flex flex-col mt-12'>
                                    <h4 className='text-lg font-bold'>{translate('setting.documentation.functions.title')}</h4>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-2'>{translate('setting.documentation.functions.description')}</p>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-1'>{translate('setting.documentation.functions.syntax')}</p>
                                    <div className='flex flex-row bg-gray-100 p-4 rounded-md mt-4 max-w-4xl'>
                                        <code className='text-sm md:text-sm'>func[functionName(arguments)]</code>
                                    </div>

                                    <div className='flex flex-col gap-4 mt-6 max-w-4xl'>
                                        <DocCard
                                            name={translate('setting.documentation.functions.round.title')}
                                            syntax={translate('setting.documentation.functions.round.syntax')}
                                            description={translate('setting.documentation.functions.round.description')}
                                            example={translate('setting.documentation.functions.round.example')}
                                        />
                                        <DocCard
                                            name={translate('setting.documentation.functions.multiply.title')}
                                            syntax={translate('setting.documentation.functions.multiply.syntax')}
                                            description={translate('setting.documentation.functions.multiply.description')}
                                            example={translate('setting.documentation.functions.multiply.example')}
                                        />
                                        <DocCard
                                            name={translate('setting.documentation.functions.addition.title')}
                                            syntax={translate('setting.documentation.functions.addition.syntax')}
                                            description={translate('setting.documentation.functions.addition.description')}
                                            example={translate('setting.documentation.functions.addition.example')}
                                        />
                                        <DocCard
                                            name={translate('setting.documentation.functions.random.title')}
                                            syntax={translate('setting.documentation.functions.random.syntax')}
                                            description={translate('setting.documentation.functions.random.description')}
                                            example={translate('setting.documentation.functions.random.example')}
                                        />
                                        <DocCard
                                            name={translate('setting.documentation.functions.sha256.title')}
                                            syntax={translate('setting.documentation.functions.sha256.syntax')}
                                            description={translate('setting.documentation.functions.sha256.description')}
                                            example={translate('setting.documentation.functions.sha256.example')}
                                        />
                                        <DocCard
                                            name={translate('setting.documentation.functions.now.title')}
                                            syntax={translate('setting.documentation.functions.now.syntax')}
                                            description={translate('setting.documentation.functions.now.description')}
                                            example={translate('setting.documentation.functions.now.example')}
                                        />
                                        <DocCard
                                            name={translate('setting.documentation.functions.substring.title')}
                                            syntax={translate('setting.documentation.functions.substring.syntax')}
                                            description={translate('setting.documentation.functions.substring.description')}
                                            example={translate('setting.documentation.functions.substring.example')}
                                        />
                                    </div>
                                </div>

                                {/* <div className='flex flex-col mt-12'>
                                    <h4 className='text-lg font-bold'>{translate('setting.documentation.comparisonOperations.title')}</h4>
                                    <p className='text-md font-medium text-gray-500 text-wrap max-w-4xl mt-2'>{translate('setting.documentation.comparisonOperations.description')}</p>

                                    <div className='flex flex-col gap-2 mt-4 max-w-4xl'>
                                        <div className='flex flex-row bg-gray-100 p-3 rounded-md'>
                                            <code className='text-sm md:text-sm'>equals</code>
                                        </div>
                                        <div className='flex flex-row bg-gray-100 p-3 rounded-md'>
                                            <code className='text-sm md:text-sm'>not_equals</code>
                                        </div>
                                        <div className='flex flex-row bg-gray-100 p-3 rounded-md'>
                                            <code className='text-sm md:text-sm'>contains</code>
                                        </div>
                                        <div className='flex flex-row bg-gray-100 p-3 rounded-md'>
                                            <code className='text-sm md:text-sm'>not_contains</code>
                                        </div>
                                        <div className='flex flex-row bg-gray-100 p-3 rounded-md'>
                                            <code className='text-sm md:text-sm'>GREATER_THAN</code>
                                        </div>
                                        <div className='flex flex-row bg-gray-100 p-3 rounded-md'>
                                            <code className='text-sm md:text-sm'>LESS_THAN</code>
                                        </div>
                                        <div className='flex flex-row bg-gray-100 p-3 rounded-md'>
                                            <code className='text-sm md:text-sm'>is_null_or_empty</code>
                                        </div>
                                        <div className='flex flex-row bg-gray-100 p-3 rounded-md'>
                                            <code className='text-sm md:text-sm'>is_not_null_or_empty</code>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </SidebarNav>
        </div>
    );
}

function DocCard({ name, syntax, description, example }) {
    return (
        <div className='border border-gray-200 rounded-md p-4 bg-white'>
            <h5 className='text-md font-bold'>{name}</h5>
            <div className='flex flex-row bg-gray-100 p-2 rounded-md mt-2'>
                <code className='text-sm'>{syntax}</code>
            </div>
            <p className='text-sm text-gray-600 mt-2'>{description}</p>
            {example && (
                <div className='flex flex-row bg-gray-50 p-2 rounded-md mt-2'>
                    <code className='text-sm text-gray-700'>Example: {example}</code>
                </div>
            )}
        </div>
    );
}
